import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { COOKIES_AUTHORIZATION } from 'utils/constants';

import { pathLogin } from './routes';

const cookies = new Cookies();

const AuthorizedRoute = props => {
  const isLoggedIn = cookies.get(COOKIES_AUTHORIZATION);

  const { component: Page, ...rest } = props;

  return (
    <Route
      {...rest}
      render={() =>
        isLoggedIn ? <Page {...props} /> : <Redirect to={pathLogin} />
      }
    />
  );
};

export default AuthorizedRoute;
